if (!customElements.get("insurance-modal")) {
  customElements.define(
    "insurance-modal",
    class extends HTMLElement {
      constructor() {
        super();
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleConfirmInsurance = this.handleConfirmInsurance.bind(this);
        this.handleRemoveInsurance = this.handleRemoveInsurance.bind(this);
        this.handleOptionalProductChange = this.handleOptionalProductChange.bind(this);
        this.handleConfirmSelectedCover = this.handleConfirmSelectedCover.bind(this);
      }

      connectedCallback() {

        this.openModalButton = document.querySelector(".insurance-modal__open-btn");
        this.confirmCoverButton = this.querySelector(".insurance-modal__confirm-cover-btn");
        this.selectYourCoverButton = this.querySelector(".insurance-modal__select-your-cover-btn");
        
        this.closeModalButtons = this.querySelectorAll(".insurance-modal__close-btn");
        this.price = document.querySelectorAll([".product-form__submit span.price", ".sticky-add-to-cart__button span.price"]);

        this.insurance_error = this.querySelector(".insurance_error")
        this.optional_error = this.querySelector(".optional_error")

        this.confirmButtons = this.querySelectorAll(".insurance-modal__confirm-btn");
        this.removeButtons = this.querySelectorAll(".insurance-modal__remove-btn");
        this.optionalProductInputs = this.querySelectorAll('input[name="optional_purchase_decision"]');

        this.insuranceIdInput = document.querySelector('input[name="insurance_variant_id"]');
        this.insuranceQtyInput = document.querySelector('input[name="insurance_variant_qty"]');
        this.insurancePriceInput = document.querySelector('input[name="insurance_variant_price"]');

        this.optionalIdInput = document.querySelector('input[name="optional_product_id"]');
        this.optionalQtyInput = document.querySelector('input[name="optional_product_qty"]');
        this.optionalPriceInput = document.querySelector('input[name="optional_product_price"]');

        this.insuranceWrapper = this.querySelectorAll(".addon-modal__insurance-coverage");
        this.optionalWrapper = this.querySelectorAll(".addon-modal__additional-products");

        if (this.openModalButton) {
          this.openModalButton.addEventListener("click", this.handleOpenModal);
        }

        if (this.confirmCoverButton) {
          this.confirmCoverButton.addEventListener("click", this.handleConfirmSelectedCover);
        }

        this.confirmButtons.forEach(btn => {
          btn.addEventListener("click", this.handleConfirmInsurance);
        });

        this.removeButtons.forEach(btn => {
          btn.addEventListener("click", this.handleRemoveInsurance);
        });

        this.optionalProductInputs.forEach(radio => {
          radio.addEventListener("change", this.handleOptionalProductChange);
        });

        this.closeModalButtons.forEach(btn => {
            btn.addEventListener("click", this.handleCloseModal);
        });
      }

      disconnectedCallback() {
        if (this.confirmButtons) {
          this.confirmButtons.forEach(btn => {
            btn.removeEventListener("click", this.handleConfirmInsurance);
          });
        }

        if (this.removeButtons) {
          this.removeButtons.forEach(btn => {
            btn.removeEventListener("click", this.handleRemoveInsurance);
          });
        }
      }

      handleConfirmInsurance(e) {
        this.querySelector(".insurance_error").style.display = "none";
        
        const button = e.currentTarget;
        const insuranceParent = button.closest(".addon-modal__insurance-coverage");
        if (!insuranceParent) return;

        insuranceParent.classList.add("addon-modal__insurance-coverage--active");

        const activeInsurance = insuranceParent;
        const insuranceItem = activeInsurance.querySelector(".insurance-modal__item");
        if (!insuranceItem) return;

        const insuranceID = insuranceItem.dataset.insuranceId;
        const insurancePrice = insuranceItem.dataset.insurancePrice;

        // Update hidden input fields
        const insuranceIdInput = document.querySelector('input[name="insurance_variant_id"]');
        const insuranceQtyInput = document.querySelector('input[name="insurance_variant_qty"]');
        const insurancePriceInput = document.querySelector('input[name="insurance_variant_price"]');

        if (insuranceIdInput) insuranceIdInput.value = insuranceID;
        if (insuranceQtyInput) insuranceQtyInput.value = '1';
        if (insurancePriceInput) insurancePriceInput.value = insurancePrice;
      }

      handleOptionalProductChange(e) {
        this.querySelector(".optional_error").style.display = "none";
        
        const input = e.currentTarget;

        const insuranceParent = input.closest(".addon-modal__additional-products");

        if (!insuranceParent) return;

        insuranceParent.classList.add("addon-modal__additional-products--active");

        const activeInsurance = insuranceParent;
        if (!activeInsurance) return;

        // Get the data attributes from the checked input
        const optionalProductId = input.value || '';
        const optionalProductQty = input.dataset.optionalProductQty || '1';
        const optionalProductPrice = input.dataset.optionalProductPrice || '';

        // Update hidden input fields
        if (this.optionalIdInput) this.optionalIdInput.value = optionalProductId;
        if (this.optionalQtyInput) this.optionalQtyInput.value = optionalProductQty;
        if (this.optionalPriceInput) this.optionalPriceInput.value = optionalProductPrice;
      }

      handleRemoveInsurance(e) {
        const button = e.currentTarget;
        const insuranceParent = button.closest(".addon-modal__insurance-coverage");
        if (!insuranceParent) return;

        insuranceParent.classList.remove("addon-modal__insurance-coverage--active");

        // Clear hidden input fields
        if (this.insuranceIdInput) this.insuranceIdInput.value = '';
        if (this.insuranceQtyInput) this.insuranceQtyInput.value = '';
        if (this.insurancePriceInput) this.insurancePriceInput.value = '';

        // Dispatch custom event to notify removal
        const event = new CustomEvent("insuranceRemoved", {
          bubbles: true,
          detail: {}
        });

        this.dispatchEvent(event);
      }

      handleOpenModal() {
        document.body.classList.add("addon-modal-open");
        this.classList.add("is-active");
      }

      handleCloseModal(resetModal = true) {

        document.body.classList.remove("addon-modal-open");
        this.classList.remove("is-active");

        if (resetModal) {
            // Safely clear active states
            this.insuranceWrapper?.forEach(wrapper => {
            wrapper.classList.remove("addon-modal__insurance-coverage--active");
            });

            this.optionalWrapper?.forEach(wrapper => {
            wrapper.classList.remove("addon-modal__additional-products--active");
            });

            // Reset hidden inputs
            if (this.insuranceIdInput) this.insuranceIdInput.value = '';
            if (this.insuranceQtyInput) this.insuranceQtyInput.value = '';
            if (this.insurancePriceInput) this.insurancePriceInput.value = '';
            if (this.optionalIdInput) this.optionalIdInput.value = '';
            if (this.optionalQtyInput) this.optionalQtyInput.value = '';
            if (this.optionalPriceInput) this.optionalPriceInput.value = '';
            if (this.openModalButton) {
                const preSelectedMessage = this.openModalButton.getAttribute("data-pre-selected-message") || "Select your cover";
                this.openModalButton.textContent = preSelectedMessage;
            }

            this.openModalButton.closest(".product-form-addon").classList.remove("product-form-addon--active");

            // Reset radio inputs
            this.optionalProductInputs?.forEach(input => {
            input.checked = false;
            });

            // Reset price to original product price
            const productObject = document.querySelector("product-form");
            if (productObject) {
                try {
                    const productData = JSON.parse(productObject.getAttribute('product'));
                    const originalPrice = productData?.price ? productData.price / 100 : 0;
                    const formattedOriginalPrice = `£${originalPrice.toFixed(2)}`;

                    this.price?.forEach(priceElement => {
                    priceElement.textContent = formattedOriginalPrice;
                    });
                } catch (error) {
                    console.warn("Could not parse product data:", error);
                }
            }

            window.selectedInsuranceData = null;
        }

        // Hide error messages safely
        const insuranceError = this.querySelector(".insurance_error");
        if (insuranceError) insuranceError.style.display = "none";

        const optionalError = this.querySelector(".optional_error");
        if (optionalError) optionalError.style.display = "none";
      }

      handleConfirmSelectedCover() {
        // Validation make sure all the hidden inputs have values
        if (!this.insuranceIdInput.value || !this.insuranceQtyInput.value || !this.insurancePriceInput.value) {
            console.error("Insurance details are incomplete. Please select an insurance cover.");
            if (this.insurance_error ) { this.insurance_error.textContent = "Please select an insurance cover."; }
            if (this.insurance_error ) { this.insurance_error.style.display = "block"; }
          return;
        }

        if (this.optionalWrapper.length > 0) {
            if (!this.optionalIdInput.value || !this.optionalQtyInput.value || !this.optionalPriceInput.value) {
                console.error("Optional product details are incomplete. Please select an optional product.");
                if (this.optional_error) { this.optional_error.textContent = "Please select an optional product."; }
                if (this.optional_error) { this.optional_error.style.display = "block"; }
              return;
            }
        }

        const mainItemPrice = document.querySelector(".product-form__submit span.price");
        if (!mainItemPrice) {
            console.error("Main item price element not found.");
            return;
        }

        const mainProductPrice = document.querySelector('input[name="product_price"]');
        const productPrice = parseFloat(mainProductPrice.value) || 0;
        const insurancePrice = parseFloat(this.insurancePriceInput.value) || 0;
        const optionalPrice = parseFloat(this.optionalPriceInput.value) || 0;
        const totalPrice = (productPrice + insurancePrice + optionalPrice) / 100;
        const formattedTotalPrice = `£${totalPrice.toFixed(2)}`;

        this.price.forEach(priceElement => {
            priceElement.textContent = formattedTotalPrice;
        });

        const selectedMessage = this.openModalButton.getAttribute("data-selected-message") || "What's covered?";
        this.openModalButton.textContent = selectedMessage;
        this.openModalButton.closest(".product-form-addon").classList.add("product-form-addon--active");

        // save to event data
        const eventData = {
          productPrice: productPrice,
          insurance_variant_id: this.insuranceIdInput.value,
          insurance_variant_qty: this.insuranceQtyInput.value,
          insurance_variant_price: this.insurancePriceInput.value,
          optional_product_id: this.optionalIdInput.value,
          optional_product_qty: this.optionalQtyInput.value,
          optional_product_price: this.optionalPriceInput.value,
          total_price: formattedTotalPrice
        };

        window.selectedInsuranceData = eventData;
        
        // close modal but dont clear the inputs
        this.handleCloseModal(false);
      }
    }
  );
}
